import React, { Fragment } from 'react';

import Text from '../../../designSystem/Text';
import Card from '../../../designSystem/Card';
import HelpDeskContent from '../HelpDeskContent';
import FooterSimple from '../../FooterSimple';

import styles from './HelpDeskContact.module.scss';

import { helpDeskTexts } from '../../../utils/generalTexts';

const HelpDeskContact = () => {
  const breadcrumbPages = [
    {
      label: helpDeskTexts.contact.breadcrumb,
      url: '',
      selected: true,
    },
  ];

  return (
    <Fragment>
      <HelpDeskContent
        breadcrumbPages={breadcrumbPages}
        title={helpDeskTexts.contact.title}
        description={helpDeskTexts.contact.description}
        content={
          <Fragment> 
            {/* <Card bordered customClass={styles.help_desk_contact_card}>
              <div className={styles.help_desk_contact_card_content}>
                <div className={styles.help_desk_contact_card_img}>
                  <img src={helpDeskTexts.contact.email.icon} alt="bicevida contacto" />
                </div>
                <div>
                  <Text
                    text={helpDeskTexts.contact.email.title}
                    customClass={styles.help_desk_contact_card_title}
                  />
                  <Text
                    text={helpDeskTexts.contact.email.description}
                    customClass={styles.help_desk_contact_card_description}
                  />
                </div>
              </div>
            </Card> */}
            <Card bordered customClass={styles.help_desk_contact_card}>
              <div className={styles.help_desk_contact_card_content}>
                <div className={styles.help_desk_contact_card_img}>
                  <img src={helpDeskTexts.contact.phone.icon} alt="bicevida contacto" />
                </div>
                <div>
                  <Text
                    text={helpDeskTexts.contact.phone.title}
                    customClass={styles.help_desk_contact_card_title}
                  />
                  <Text
                    text={helpDeskTexts.contact.phone.description}
                    customClass={styles.help_desk_contact_card_description}
                  />
                </div>
              </div>
            </Card>
          </Fragment>
        }
      />

      <FooterSimple />
    </Fragment>
  );
};

export default HelpDeskContact;
